import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ProfitReport from './components/ProductAdsReport';

const ProductAdsPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Product Ads</h3>
      </Col>
    </Row>
    <Row>
      <ProfitReport />
    </Row>
  </Container>
);

export default ProductAdsPage;
